import { Text, Box } from 'braid-design-system';

export const MenuButton = ({
  children,
  isActive = false,
  isDisabled = false,
  onClick,
}: {
  children: React.ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
}) => {
  const getBackground = () => {
    if (isActive) {
      return 'neutral';
    }
    if (isDisabled) {
      return 'surface';
    }
    return 'neutralSoft';
  };

  return (
    <Box
      background={getBackground()}
      borderRadius="small"
      style={{
        height: 32,
        width: 48,
        margin: '0 2px',
        cursor: isDisabled ? 'default' : 'pointer',
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      component="button"
      onClick={(e) => {
        e.preventDefault();
        onClick?.(e);
      }}
    >
      <Text>{children}</Text>
    </Box>
  );
};
